import * as saveDialogViewModel from 'model/ISaveDialogViewModel';

export const initPageState = (): saveDialogViewModel.SaveDetailsState => {
    let init: saveDialogViewModel.SaveDetailsState = {
        country: "",
        firstname: "",
        lastname: "",
        email: "",
        confirmEmail: "",
        mobile: "",
        comments: "",
        checkMarketingComms: false,
        checkPrivacy: false,
        invalidCountry: false,
        invalidFirstname: false,
        invalidLastname: false,
        invalidEmail: false,
        invalidConfirmEmail: false,
        invalidMobile: false,
        emailMismatch: false,
        invalidCheckMarketingComms: false,
        invalidCheckPrivacy: false,
    }
    return init;
}